<template>
  <b-modal
    id="create-building-modal"
    title="Building Create Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">Building Create</h2>
    </template>
    <validation-observer ref="buildingCreateFormValidation">
      <b-form @submit.prevent enctype="multipart/form-data">
        <validation-provider
          rules="required"
          v-slot="{ errors }"
          name="Site">
          <b-form-group label-for="site">
            <template #label>
              Site <span class="text-danger">*</span>
            </template>
            <v-select
              label="name"
              v-model="site"
              placeholder="Select Site"
              :options="sites"
              autoscroll
              :clearable="true"
            ></v-select>
          </b-form-group>
          <p class="text-danger">{{ errors[0] }}</p>
        </validation-provider>

        <validation-provider
          rules="required"
          v-slot="{ errors }"
          name="Building Name">
            <b-form-group label-for="name">
              <template #label>
                Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="name"
                v-model="name"
                v-restrict="regex"
                placeholder="Name"
              />
            </b-form-group>
          <p class="text-danger">{{ errors[0] }}</p>
        </validation-provider>

        <validation-provider
          rules="required"
          v-slot="{ errors }"
          name="Building Type">
          <b-form-group label-for="building_type">
            <template #label>
              Building Type <span class="text-danger">*</span>
            </template>
            <v-select
              label="name"
              v-model="building_type"
              placeholder="Select Building Type"
              :options="building_types"
              autoscroll
              :clearable="true"
            ></v-select>
          </b-form-group>
          <p class="text-danger">{{ errors[0] }}</p>
        </validation-provider>

        <!-- Address Input Field -->
        <validation-provider
          rules="required"
          v-slot="{ errors }"
          name="Address"
        >
          <b-form-group label-for="address">
            <template #label>
              Address <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="autocomplete"
              v-model="address"
              placeholder="Enter your address"
            />
          </b-form-group>
          <p class="text-danger">{{ errors[0] }}</p>
        </validation-provider>


        <validation-provider
          rules="required"
          v-slot="{ errors }"
          name="ASE #"
        >
          <b-form-group label-for="ase_number">
            <template #label>
              ASE # <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="ase_number"
              v-model="ase_number"
              placeholder="ASE #"
              type="number"
            />
          </b-form-group>
          <p class="text-danger">{{ errors[0] }}</p>
        </validation-provider>

        <b-form-group class="mt-2 text-right">
          <b-button
            type="submit"
            variant="primary"
            pill
            class="mr-1"
            @click="validateAndSubmit"
          >
            Save
          </b-button>
          <b-button
            type="reset"
            variant="outline-secondary"
            @click="reset"
            pill
          >
            Reset
          </b-button>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  mixins: [util],
  data() {
    return {
      required,
      name: "",
      building_type: "",
      address: "",
      latitude: null,
      longitude: null,
      regex: /^[a-zA-Z ]*$/,
      building_types: [
        {
          name: "Apartment",
          value: "Apartment"
        },
        {
          name: "Town House",
          value: "Town House"
        },
      ],
      sites: [],
      site: "",
      ase_number: "",
    };
  },
  methods: {
    ...mapActions({
      createBuilding: "appData/createBuilding",
      getSitesDDL: "appData/getSitesDDL",
    }),

    async validateAndSubmit() {
      // Validate the whole form before submission
      const isValid = await this.$refs.buildingCreateFormValidation.validate();
      if (isValid) {
        this.submit();
      } else {
        console.log("asdfasdf");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Form submission failed",
            text: "Please ensure all required fields are filled correctly.",
            variant: "danger",
            icon: "AlertCircleIcon",
          },
        });
      }
    },

    async submit() {
      try {
        const formData = new FormData();
        formData.append("name", this.name);
        formData.append("site", this.site.id);
        formData.append("building_type", this.building_type.value);
        formData.append("address", this.address);
        formData.append("latitude", this.latitude);
        formData.append("longitude", this.longitude);
        formData.append("ase_number", this.ase_number);
        formData.append("created_by", this.getLoggedInUser.id);
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.createBuilding(formData);
        if (res.status === 201) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Building Created Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("create-building-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    reset() {
      this.name = "";
      this.address = "";
      this.building_type = "";
      this.latitude = null;
      this.longitude = null;
      this.site = "";
      this.ase_number = "";
    },

    initAutocomplete() {
      const input = document.getElementById('autocomplete');
      const autocomplete = new google.maps.places.Autocomplete(input);

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) {
          console.log('Returned place contains no geometry');
          return;
        }
        this.address = place.formatted_address;
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
      });
    }
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
  async mounted() {
    const sites = await this.getSitesDDL();
    this.sites = sites.data;
    this.initAutocomplete();
  },
};
</script>

<style>
/* Ensure the dropdown menu appears above the modal */
.pac-container {
  z-index: 1051 !important; /* Higher than modal z-index */
}
</style>
